import { memo } from 'react';

import { Heading, Separator, Text } from '@/components/core';

import { Page } from './Page';
import { PersonalData } from './PersonalData.tsx';
import { WorkspaceHeader } from './WorkspaceHeader.tsx';

export type SecurityProps = object;

// eslint-disable-next-line no-empty-pattern
const ISecurity = ({}: SecurityProps) => {
  return (
    <Page className="gap-md">
      <WorkspaceHeader>
        <Heading>Security</Heading>
        <Text>
          Manage your data protection settings and compliance options.{' '}
          <span
            onClick={() => window.open('https://docs.cradl.ai/legal/dpa', '_blank')}
            className="cursor-pointer font-semibold underline"
          >
            Read more
          </span>{' '}
        </Text>
      </WorkspaceHeader>

      <Separator orientation="horizontal" />

      <PersonalData />
    </Page>
  );
};

export const Security = memo(ISecurity) as typeof ISecurity;
